import { render, staticRenderFns } from "./BCXMessengerFilters.vue?vue&type=template&id=3fbb3338&scoped=true"
import script from "./BCXMessengerFilters.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerFilters.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerFilters.vue?vue&type=style&index=0&id=3fbb3338&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb3338",
  null
  
)

export default component.exports